export default class Breakpoint {
  constructor(el) {
    this.container = el;
    this.breakpoint = {};
    this.children = this.getChildren();
    this.observer = new ResizeObserver(() => this.toggleClass());
    this.observer.observe(this.container);
    if (this.container.getAttribute('data-breakpoint') !== '') {
      setTimeout(() => this.init(), 5);
    } else {
      console.warn('Please add a classname to the data-breakpoint attribute');
    }
  }
  toggleClass() {
    for (let key in this.breakpoint) {
      this.container.offsetWidth >= this.breakpoint[key] ? this.container.classList.remove(`js-breakpoint-${key}`) : this.container.classList.add(`js-breakpoint-${key}`);
    }
  }
  getChildren() {
    let childHolder = {};
    let allChildren = [...this.container.querySelectorAll('[data-breakpoint-watch]')];
    let identifiers = this.container.getAttribute('data-breakpoint').split(',');
    identifiers.forEach(ID => {
      this.breakpoint[ID] = 250;
      childHolder[ID] = [];
      allChildren.forEach(child => {
        if (child.getAttribute('data-breakpoint-watch').indexOf(ID) > -1) childHolder[ID].push(child);
      });
    });
    return childHolder;
  }
  init() {
    // Create the breakpoint
    for (let key in this.children) {
      this.children[key].forEach(child => {
        this.breakpoint[key] += child.offsetWidth;
        this.breakpoint[key] += parseInt(window.getComputedStyle(child).marginLeft);
        this.breakpoint[key] += parseInt(window.getComputedStyle(child).marginRight);
      });
    }
    this.container.classList.add('js-breakpoint');
  }
}